import { render } from "./Host.vue?vue&type=template&id=484d7511&scoped=true"
import script from "./Host.vue?vue&type=script&lang=js"
export * from "./Host.vue?vue&type=script&lang=js"

import "./Host.vue?vue&type=style&index=0&id=484d7511&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484d7511"]])

export default __exports__